export function groupLineItemsByUnitPrice(customerOrderLineItems) {
  const groups = [];
  if (!Array.isArray(customerOrderLineItems)) return groups;
  customerOrderLineItems.forEach(({ Canceled, Quantity, UnitPrice }) => {
    if (!Quantity || Boolean(Canceled)) return;
    const index = groups.findIndex(
      (g) => Math.round(g.UnitPrice * 100) === Math.round(UnitPrice * 100),
    );
    if (index > -1) {
      groups[index] = { UnitPrice: Math.round(UnitPrice * 100) / 100, Quantity: groups[index].Quantity + Quantity };
    } else {
      groups.push({ UnitPrice, Quantity });
    }
  });
  return groups;
}
